import React from 'react';
import Timesheets from './Timesheets';

const AdminApprovals = () => {
  return <Timesheets initialTab="approvals" showAdminTabs={true} />;
};

export default AdminApprovals;
